'use strict';

exports.__esModule = true;
exports['default'] = removeClass;

function removeClass(el, classNames) {
    if (el.classList) {
        return classNames.forEach(function (cl) {
            el.classList.remove(cl);
        });
    }
    el.className = el.className.replace(new RegExp('(^|\\b)' + classNames.join('|') + '(\\b|$)', 'gi'), ' ');
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-custom-scrollbars/lib/utils/removeClass.js
// module id = 215
// module chunks = 0 1 9